<template>
  <div ref="turnstileContainer"></div>
</template>

<script>
export default {
  name: "VueTurnstile",
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: "light"
    }
  },
  data() {
    return {
      widgetId: null
    };
  },
  mounted() {
    this.initializeTurnstile();
  },
  beforeDestroy() {
    this.reset();
  },
  methods: {
    initializeTurnstile() {
      if (!window.turnstile) {
        if (!document.getElementById("cloudflare-turnstile-script")) {
          const script = document.createElement("script");
          script.id = "cloudflare-turnstile-script";
          script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
        
        const checkTurnstile = setInterval(() => {
          if (window.turnstile) {
            clearInterval(checkTurnstile);
            this.renderWidget();
          }
        }, 100);
      } else {
        this.renderWidget();
      }
    },
    renderWidget() {
      if (!window.turnstile || !this.$refs.turnstileContainer) return;
      
      try {
        this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
          sitekey: this.sitekey,
          theme: this.theme,
          callback: (token) => {
            this.$emit("verify", token);
          },
          "expired-callback": () => {
            this.$emit("expired");
          },
          "error-callback": (err) => {
            this.$emit("error", err);
          }
        });
      } catch (e) {
        console.error("Failed to render Turnstile widget:", e);
      }
    },
    reset() {
      if (window.turnstile && this.widgetId !== null) {
        try {
          window.turnstile.reset(this.widgetId);
        } catch (e) {
          console.error("Failed to reset Turnstile widget:", e);
        }
      }
    }
  }
};
</script>
